import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ModelService } from 'src/app/services/model.service';
import { ConfigService } from 'src/app/app.config';

@Injectable({
	providedIn: 'root'
})
export class HoldGuard implements CanActivate {

    constructor(
        private modelService: ModelService,
        private router: Router) {}

    public canActivate(): boolean {
        if (!this.modelService.getUser().hasToken) {
        	if (ConfigService.DEBUG) return true;
        	this.router.navigate(['/login']);
        	return false;
        }
        return true;
    }
}